import { render, staticRenderFns } from "./m-dialog-form.vue?vue&type=template&id=75fecb9e&scoped=true&lang=pug&"
import script from "./m-dialog-form.vue?vue&type=script&lang=js&"
export * from "./m-dialog-form.vue?vue&type=script&lang=js&"
import style0 from "./m-dialog-form.vue?vue&type=style&index=0&id=75fecb9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fecb9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VForm})
